module.exports = __webpack_public_path__ + "static/media/flokk.2f3b0f35.mp3";